import { Link } from 'react-router-dom'
import { FiXCircle } from 'react-icons/fi'

const BillingCancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-blue-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-6">
          <FiXCircle className="h-10 w-10 text-gray-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Pago cancelado</h1>
        <p className="text-gray-600 mb-8">
          Has cancelado el proceso de pago. Puedes intentarlo de nuevo cuando quieras.
        </p>
        <div className="space-y-3">
          <Link
            to="/configuracion?tab=plan"
            className="block w-full py-3 px-6 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-colors"
          >
            Volver a planes
          </Link>
          <Link
            to="/"
            className="block w-full py-3 px-6 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
          >
            Ir al panel
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BillingCancel
